import {useContext} from 'react';

import {FormikValues} from 'formik';

import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import {Autocomplete, Box, Checkbox, TextField, useTheme} from '@mui/material';

import {adminsMultiSelectStyles} from './AdminsMultiSelectStyles';
import {CompanyContext} from '../../../../../../../../../contexts/CompanyContext/CompanyContext';
import {getFieldStyle} from '../../../../../../../../../layouts/theme/FieldStyles';

interface Props {
  formik: FormikValues;
}

interface Option {
  label: string;
  value: string;
}

export const AdminsMultiSelect = ({formik}: Props) => {
  const {companyAdmins} = useContext(CompanyContext);

  const theme = useTheme();

  const icon = <CheckBoxOutlineBlankIcon fontSize='small' />;
  const checkedIcon = <CheckBoxIcon fontSize='small' color='action' />;

  // Ensure the value is always defined
  const assignAdminsValue = formik.values.companyAdminIds || [];

  const companyAdminsOptions: Option[] =
    companyAdmins.data?.companyAdmins.map((admin) => ({
      value: admin.resourceId,
      label: `${admin.firstName} ${admin.lastName}`,
    })) || [];

  return (
    <Box marginTop={3}>
      <Autocomplete
        options={companyAdminsOptions}
        fullWidth
        multiple
        disableCloseOnSelect
        sx={{...getFieldStyle(theme), ...adminsMultiSelectStyles(theme)}}
        value={companyAdminsOptions.filter((option) => assignAdminsValue.includes(option.value))}
        onChange={(_event, value) => {
          formik.setFieldValue(
            'companyAdminIds',
            value.map((option: Option) => option.value)
          );
        }}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        getOptionLabel={(option) => option.label}
        renderOption={(props, option: Option, {selected}) => (
          <li {...props} key={option.value}>
            <Checkbox icon={icon} checkedIcon={checkedIcon} style={{marginRight: 8}} checked={selected} />
            {option.label}
          </li>
        )}
        renderInput={(params) => <TextField {...params} fullWidth name='assignAdmins' />}
      />
    </Box>
  );
};
